"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.userInfoBaseSchema = exports.userInfoFormFields = exports.userInfoSchema = void 0;
const form_field_types_1 = require("@App/enum/form-field-types");
const zod_1 = require("zod");
const error_messages_1 = require("@Entities/schemas/work/error-messages");
const error_messages_2 = require("@Const/error-messages");
const address_schema_1 = require("@Entities/schemas/common/address-schema");
const phone_number_schema_1 = require("@Entities/schemas/common/phone-number-schema");
const user_settings_1 = require("@Entities/schemas/user/user-settings");
const populate_schema_1 = __importDefault(require("@App/forms/v2/helpers/populate-schema"));
const validate_1 = require("@App/helpers/validate");
const user_groups_1 = require("@Entities/schemas/user/user-groups");
const idKey = 'id';
const firstNameKey = 'firstName';
const firstNameLabel = 'First Name';
const lastNameKey = 'lastName';
const lastNameLabel = 'Last Name';
const birthdayKey = 'birthday';
const birthdayLabel = 'Date Of Birth';
const emailKey = 'email';
const emailLabel = 'Email Address';
const invitationSentTimestampKey = 'invitationSentTimestamp';
const activeKey = 'active';
const lastActivityKey = 'lastActivity';
const validationStatusKey = 'validationStatus';
const verificationStatusKey = 'verificationStatus';
const rolesKey = 'roles';
const isInternalUserKey = 'isInternalUser';
const usernameKey = 'username';
const userInfoBaseSchema = zod_1.z.object({
    [firstNameKey]: zod_1.z
        .string({
        required_error: error_messages_2.REQUIRED_MESSAGE,
    })
        .min(1, error_messages_2.REQUIRED_MESSAGE)
        .max(60, (0, error_messages_1.stringSizeMaxMessage)(firstNameLabel, 60)),
    [lastNameKey]: zod_1.z
        .string({
        required_error: error_messages_2.REQUIRED_MESSAGE,
    })
        .min(1, error_messages_2.REQUIRED_MESSAGE)
        .max(60, (0, error_messages_1.stringSizeMaxMessage)(lastNameLabel, 60)),
    [birthdayKey]: zod_1.z
        .date({
        errorMap: (issue, _ctx) => ({ message: 'Required' }),
    })
        .max(new Date(), error_messages_2.BIRTHDAY_ERROR_MESSAGE),
    [emailKey]: zod_1.z
        .string()
        .min(1, error_messages_2.REQUIRED_MESSAGE)
        .trim()
        .toLowerCase()
        .email(error_messages_2.EMAIL_MESSAGE)
        .max(2000, (0, error_messages_1.stringSizeMaxMessage)(emailLabel, 2000))
        .refine(validate_1.isNotAnReservedEmailBoolean, error_messages_2.NO_RESERVED_EMAIL_MESSAGE),
    [address_schema_1.addressFormKey]: address_schema_1.userAddressSchema,
    [phone_number_schema_1.phoneNumberFormKey]: phone_number_schema_1.phoneNumberSchema,
});
exports.userInfoBaseSchema = userInfoBaseSchema;
const userInfoSchema = userInfoBaseSchema.merge(zod_1.z.object({
    [idKey]: zod_1.z.optional(zod_1.z.string()),
    [user_settings_1.settingsFormKey]: user_settings_1.settingsSchema.optional(),
    [user_groups_1.groupsFormKey]: user_groups_1.groupsSchema.optional(),
    [invitationSentTimestampKey]: zod_1.z.optional(zod_1.z.string()).nullable(),
    [activeKey]: zod_1.z.optional(zod_1.z.boolean()),
    [lastActivityKey]: zod_1.z.optional(zod_1.z.number()).nullable(),
    [validationStatusKey]: zod_1.z.optional(zod_1.z.string()).nullable(),
    [verificationStatusKey]: zod_1.z.optional(zod_1.z.string()).nullable(),
    [rolesKey]: zod_1.z.optional(zod_1.z.array(zod_1.z.string())),
    [isInternalUserKey]: zod_1.z.optional(zod_1.z.boolean()),
    [usernameKey]: zod_1.z
        .string()
        .min(1, error_messages_2.REQUIRED_MESSAGE)
        .trim()
        .toLowerCase()
        .email(error_messages_2.EMAIL_MESSAGE)
        .max(2000, (0, error_messages_1.stringSizeMaxMessage)(emailLabel, 2000))
        .refine(validate_1.isNotAnReservedEmailBoolean, error_messages_2.NO_RESERVED_EMAIL_MESSAGE),
}));
exports.userInfoSchema = userInfoSchema;
const userInfoFormFieldsNoSchema = {
    [firstNameKey]: {
        name: firstNameKey,
        label: firstNameLabel,
        type: form_field_types_1.FormFieldTypes.TEXT,
    },
    [lastNameKey]: {
        name: lastNameKey,
        label: lastNameLabel,
        type: form_field_types_1.FormFieldTypes.TEXT,
    },
    [birthdayKey]: {
        name: birthdayKey,
        label: birthdayLabel,
        type: form_field_types_1.FormFieldTypes.DATEPICKER,
    },
    [emailKey]: {
        name: emailKey,
        label: emailLabel,
        type: form_field_types_1.FormFieldTypes.TEXT,
        isDisabled: true,
    },
    [address_schema_1.addressFormKey]: address_schema_1.userAddressFormFields,
    [phone_number_schema_1.phoneNumberFormKey]: phone_number_schema_1.phoneNumberFormFields,
};
const userInfoFormFields = (0, populate_schema_1.default)(userInfoFormFieldsNoSchema, userInfoSchema);
exports.userInfoFormFields = userInfoFormFields;
